import { Box, styled } from '@mui/material';
import { chromeYellow, spaceCadet } from '../../../../../utils/colors';

export const CountBadge = styled(Box)({
  minWidth: 18,
  height: 18,
  padding: '0 5px',
  borderRadius: 9,
  backgroundColor: chromeYellow[500],
  color: chromeYellow[800],
  fontSize: 11,
  fontWeight: 700,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const EmptyState = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 12,
  padding: '0 40px',
  textAlign: 'center',

  '& > svg': {
    fontSize: 30,
    color: spaceCadet[300],
  },

  '& .MuiTypography-root': {
    color: spaceCadet[400],
  },
});
